/**
 * Capitalize the first letter of a string and optionally lowercase the rest of the string
 */
export const capitalize = (text: string, lowerRest = false) => {
  const [first, ...rest] = text
  return first.toUpperCase() + (lowerRest ? rest.join('').toLowerCase() : rest.join(''))
}
